import styled from 'styled-components';
import { FallbackEN } from '@/assets/images';
import { ScreenWrapper } from '@CS/app/App.styles';

export default styled(ScreenWrapper)`
  background-image: url('${FallbackEN}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;
